export const useEditStore = defineStore("edit", () => {
  const data = reactive({
    city: null,
    admin: null,
    country: null,
    sub: null,
    place: null,

    tags: [],
    type: null,

    activeDates: {},
    canceledDates: {},

    title: null,

    contactMessaging: null,
    contactEmail: null,
    contactPhone: null,
    phone1: null,
    phone2: null,
    email1: null,
    email2: null,
    codePhone1: "FR",
    codePhone2: "FR",

    isOrga: null,

    periodicity: null,

    exhMaxCount: null,
    exhInfo: null,
    exhFile: null,
    exhFileUrl: null,
    exhUrl: null,

    paying: null,
    price: null,
    website: null,
    schedule: null,
    description: null,
    loto: null,

    video: null,
    pictures: [],
    picturesUrl: [],

    inside: false,
    outside: false,

    catering: false,
    bar: false,
    parking: false,
    wc: false,
    accessibility: false,
    atm: false,

    selectedLocation: null,
  });

  const reset = () => {
    data.selectedLocation = null;

    data.city = null;
    data.admin = null;
    data.country = null;
    data.sub = null;
    data.place = null;

    data.tags = [];
    data.type = null;

    data.activeDates = {};
    data.canceledDates = {};

    data.title = null;

    data.contactMessaging = null;
    data.contactEmail = null;
    data.contactPhone = null;
    data.phone1 = null;
    data.phone2 = null;
    data.email1 = null;
    data.email2 = null;
    data.codePhone1 = "FR";
    data.codePhone2 = "FR";

    data.isOrga = null;

    data.periodicity = null;

    data.exhMaxCount = null;
    data.exhInfo = null;
    data.exhFile = null;
    data.exhFileUrl = null;
    data.exhUrl = null;

    data.paying = null;
    data.price = null;
    data.website = null;
    data.schedule = null;
    data.description = null;
    data.loto = null;

    data.video = null;
    data.pictures = [];
    data.picturesUrl = [];

    data.inside = null;
    data.outside = null;

    data.catering = false;
    data.bar = false;
    data.parking = null;
    data.wc = null;
    data.accessibility = false;
    data.atm = false;
  };
  const agendas = [];
  return {
    data,
    agendas,
    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useEventStore, import.meta.hot));
}
